/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Swedish (Sweden): sv-se
 */

/**
 * Translation file for sv-SE locale
 *
 * @file sv.js
 * @author Mohamed yasar arabath M
 */

const sv = {
  'popularChannelSlider.allChannels': 'Alla kanaler',
  'popularChannelSlider.recommended': 'Rekommenderas',
  'hero.myetextbook.link': 'bibliotek',
  'hero.myetextbook.text': 'Inte den rätta titeln? Få åtkomst till din e-lärobok',
  'hero.etextfeaturestitle': 'Hitta studiematerial i din e-lärobok',
  'hero.etextfeaturesdescription': 'Din e-lärobok innehåller studiematerial som är utformat för att hjälpa dig att lyckas. Studera med flashkort och mycket mer direkt i din e-lärobok.',
  'aichat.title1': 'Få AI-driven hjälp om något relaterat till denna e-lärobok.',
  'aichat.chatDesc1': 'Skriv in en fråga för att komma igång',
  'subscriptiontext.isSubscribed': 'Del av din prenumeration',
  'subscriptiontext.nonSubscriber': 'Uppgradera för fullständig åtkomst',
  'topicConatiner.otherHeader': 'Relaterade videoklipp och övning',
  'topicConatiner.exactLiteHeader': 'Relaterade begrepp och övning',
  'moremenu.downloadApp': 'Ladda ner appen',
  'moremenu.downloadAppAlreadyDownload': '%Click here% för att ladda ner appen på en annan enhet och logga in automatiskt eller för att använda din unika QR-kod för att logga in säkert på den app du redan har installerat.',
  'moremenu.downloadAppNotDownload': '%Click here% för att ladda ner appen och logga in säkert med din unika QR-kod',
  'channel.noBundletitle': 'Använd studieförberedelse för dina relaterade och andra kurser',
  'onboard.studyPlan': 'Anpassad studieplan skapad!',
  'onboard.addCourseAnother': 'Vill du lägga till en till kurs?',
  'onboard.purchase': 'Jag behöver köpa en Pearson e-lärobok',
  'onboard.addCourseWithoutEtext': 'Lägg till kurs med hjälp av Studieförberedelse',
  'onboard.mayBeLater': 'Kanske senare',
  'onboard.aboutCourse': 'Berätta för oss om din kurs',
  'onboard.close': 'Stäng',
  'course.addTitle': 'Lägg till kurs',
  'common.PURCHASE': 'Köp',
  'common.CLOSE': 'Stäng',
  'open': 'öppna',
  'continue': 'Fortsätt',
  'yes': 'Ja',
  'no': 'Nej',
  'audio': 'Ljud',
  'courses.toc.PUBLISH_SUCCESS': 'Lyckades!',
  'courses.toc.PUBLISH_MESSAGE': 'Studenterna kommer att se dina ändringar nästa gång de öppnar innehållet.',
  'errors.GENERIC_TITLE': 'Du har inte åtkomst just nu',
  'errors.GENERIC_DESC': 'Börja med att uppdatera eller rensa dina cache. Om det inte fungerar ska du kontakta Pearson- ',
  'errors.GENERIC_LINK': 'support.',
  'errors.GENERIC_CODE': 'Felkod: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Prenumeration hittades inte',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Ditt konto inkluderar inte tillgång till denna titel. Om du tror att du har fått detta meddelande av misstag kontaktar du Pearson teknisk support',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Prenumeration hittades inte',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Din prenumeration inkluderar inte tillgång till e-textboken, men du kan prenumerera på den direkt med ett kreditkort.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/higher-education/products-services-teaching/course-content/textbooks-and-etexts/pearson-etext/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Mitt konto',
  'menu.helpCenter': 'Hjälpcenter',
  'menu.preferencesCenter': 'Preferenscenter',
  'menu.CONTACT_SUPPORT': 'Kontakta Support',
  'menu.HELP_SUPPORT': 'Hjälp & support',
  'menu.FAQS': 'FAQ',
  'menu.CHAT_WITH_SUPPORT': 'Chatta med support',
  'menu.OTP_CODES': 'OTP-koder',
  'menu.LAUNCH_CODE': 'Starta kodlogg',
  'menu.SEND_CODE': 'Skicka ny kod till användare via e-post',
  'menu.SEND_CODE_PHONE': 'Skicka ny kod till användare via textmeddelande',
  'menu.LEGAL': 'Juridiskt',
  'menu.PRIVACY_NOTICE': 'Sekretessmeddelande',
  'menu.TITLE_INFO': 'Titelinformation',
  'menu.PEARSON_ACCESSIBILITY': 'Pearson-tillgänglighet',
  'menu.DEVICE_WARNING_MESSAGE': 'Registrera {deviceLimit} enheter. Byt ut 1 per månad.',
  'menu.ACCESSIBILITY': 'Tillgänglighet',
  'menu.ACCESSIBILITY_SUPPORT': 'Tillgänglighetssupport',
  'menu.DEVICES': 'Senaste enheter',
  'menu.THIS_DEVICE': 'Denna enhet',
  'menu.GET_THE_APP_DOWNLOAD': 'Ladda ner mobilappen',
  'menu.MOJO_APP_INFO': 'Gå till appbutiken på din telefon eller surfplatta för att använda Pearson+ offline.',
  'menu.DEVICE_LABEL': 'Enhet',
  'menu.DEVICE_DISCONNECT': 'Frånkoppla',
  'menu.FOXIT': 'Drivs av FoxIT',
  'menu.TERMS_OF_USE': 'Användarvillkor',
  'menu.SIGN_OUT': 'Logga ut',
  'menu.PRINT_PAGE': 'Skriv ut sida',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. All Rights Reserved.',
  'print.FOOTER_MESSAGE': 'Tryckt av {fullName}({email}) den {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Du har redan bytt denna månad',
  'device.SWITCH_DEVICE': 'Byt till nuvarande enhet?',
  'device.SWITCH_ONCE': 'Eftersom du bara kan byta en gång i månaden kan du inte ångra detta.',
  'device.SEAT_TAKEN': 'Denna plats är upptagen',
  'device.DISCONNECT_DEVICE': 'Du kan endast logga in på 3 enheter. För att fortsätta här frånkopplar du en annan enhet.',
  'device.ALERT_TEXT': 'Kom ihåg att du bara kan byta enhet en gång per månad.',
  'device.DISCONNECT': 'Frånkoppla',
  'device.CONTINUE': 'Fortsätt',
  'device.HEADER': 'Avsluta din andra webbläsarsession?',
  'device.CLOSE': 'Tillbaka till startsidan',
  'device.CODE': 'Fortsätt här genom att ange den autentiseringskod som vi har skickat till {maskedEmail}. Fungerar den inte? Kontrollera din mapp med skräppost, {email}, eller kontakta {support}.',
  'device.TIMER': 'Du har {time} på dig att ange din kod här',
  'device.RESEND': '{resend}',
  'device.FAQ': 'FAQ',
  'device.RESEND_NAME': 'Skicka igen',
  'device.NOTE': 'Om du regelbundet använder Pearson+ på 2 platser, såsom på jobbet och hemma, ska du se till att logga ut när du är klar. Du kan använda Pearson+-mobilappen på upp till 2 enheter. Mer information finns i vår {faq}.',
  'device.NOTE_HEADER': 'Undvik detta nästa gång',
  'device.CONTACT_SUPPORT': 'kundsupport',
  'device.CONTACT_EMAIL': 'uppdatera din e-postadress',
  'device.INCORRECT': 'Fel – dubbelkontrollera din kod eller skicka den igen.',
  'device.MANY_ATTEMPTS': 'För många försök, försök skicka koden igen',
  'device.EXPIRED': 'Din tid har gått ut, försök skicka koden igen',
  'device.ACCESS_HEADER': 'Du är inne!',
  'device.ACCESS_DESC': 'Din session har autentiserats. Vill du uppdatera ditt lösenord när du ändå håller på?',
  'device.ACCESS_CHANGE_PASSWORD': 'Ändra lösenord',
  'device.ACCESS_RESET_PASSWORD': 'Återställ lösenord',
  'device.THREATONE_TITLE': 'Allt bra?',
  'device.THREATONE_DESC': 'Vi har upptäckt misstänkt aktivitet på ditt konto.',
  'device.THREATONE_DESC_TWO': 'Detta är en bra tidpunkt att byta ditt lösenord.',
  'device.MAY_BE_LATER': 'Kanske senare',
  'device.OKAY': 'Okej',
  'device.ACCOUNT_LOCK_DESC': 'För att hålla det säkert kommer vi att logga ut dig. Vi har skickat en länk för återställning av lösenord till den e-postadress som är kopplad till ditt konto.',
  'device.ACCOUNT_LOCK_TITLE': 'Vi märkte av lite skum aktivitet på ditt konto',
  'device.ACCOUNT_LOCK_TIMER': 'Du kommer att loggas ut om {time}',
  'navigation.PAGE': 'Sida',
  'launchcode.CREATEBY': 'Skapad av:',
  'launchcode.sentvia': 'Skickad via:',
  'launchcode.CODEINLAST': 'Koder under de senaste 7 dagarna:',
  'launchcode.TIMESENT': 'Tid skickad: ',
  'launchcode.ACCOUNTEMAIL': 'E-postadress för konto:',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP-kodlogg',
  'textmessage.TITLE': 'Ange telefonnummer',
  'textmessage.PHONE_NUMBER': 'Telefonnummer',
  'textmessage.SEND_CODE': 'Skicka kod',
  'textmessage.INVALID_NUMBER': 'Ogiltigt telefonnummer.',
  'textmessage.SUCCESS_MESSAGE': 'Kod skickad',
  'remove.title': 'Ta bort titel?',
  'remove.subTitle': 'Du kan alltid gå tillbaka den senare – använd bara sökningen för att lägga till den igen.',
  'remove.buttonText': 'Ta bort',
  'search.searchPlaceHolderPPlus': 'Sök efter ISBN, titel eller författare',
  'search.searchPlaceHolderEText': 'Sök dit bibliotek',
  'footer.downloadMobileApp': 'Ladda ner mobilappen',
  'footer.termsOfUse': 'Användarvillkor',
  'footer.privacy': 'Sekretess',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Sälj inte min personliga information',
  'footer.accessibility': 'Tillgänglighet',
  'footer.patentNotice': 'Patentmeddelande',
  'footer.copyrights': 'Pearson Alla rättigheter förbehållna.',
  'hero.toc.defaultPlacehoder': '--- välj ett ämne ---',
  'hero.openEtextBookV1': 'Öppna e-lärobok',
  'hero.heroHeading': 'Eftersom du studerar <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Studieförberedelse',
  'hero.study.help': 'Få studiehjälp',
  'hero.study.jumpBackIn': 'Dags att återgå',
  'hero.study.numOfUsers': 'För tillfället är det <b>{num_of_users}</b> studenter som använder Kanaler.',
  'hero.heroChannel.cardsHeading': 'Fortsätt från där du slutade',
  'hero.marketingcard1.copy.title': 'Lär dig med videor',
  'hero.marketingcard1.copy.description': 'Titta på korta videor som förklarar svåra ämnen.',
  'hero.marketingcard2.copy.title': 'Övningsuppgifter',
  'hero.marketingcard2.copy.description': 'Förbered dig på examen med tusentals examensliknande frågor och videolösningar.',
  'hero.marketingcard3.copy.title': 'Få erfaren hjälp',
  'hero.marketingcard3.copy.description': 'Publicera frågor och får svar från ämnesexperter.',
  'hero.popularTopics.heading': 'Andra populära ämnen i denna Kanal',
  'hero.popularChannels.headingv1': 'Ta en annan kurs?',
  'hero.popularChannels.descriptionv2': 'Bläddra i populära studiehjälpsämnen.',
  'hero.practice': 'Öva',
  'hero.herobook.mappedChannelHeading': 'Rekommenderad studiehjälp i denna kanal',
  'libraryL2.myBooks': 'Mina böcker',
  'libraryL2.archived': 'Arkiverade',
  'libraryL2.back': 'Tillbaka',
  'hero.practiceProblem': 'Övningsuppgift',
  'nativeAppBanner.drawer.title': 'Öppna i ...',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+-appen',
  'nativeAppBanner.banner.title': 'Pearson+-appen',
  'nativeAppBanner.banner.description': 'Lär dig när du är på språng',
  'hero.promotionalcard.list1': 'Korta videor som förklarar svåra ämnen',
  'hero.promotionalcard.list2': 'Tusentals examensliknande frågor',
  'hero.promotionalcard.list3': 'Få svar från ämnesexperter',
  'hero.studyandexamprep': 'Studieförberedelse',
  'hero.heroBook.sectionSubHeadingV1': 'Dela in tuffa ämnen med videoförklaringar och övningsfrågor skräddarsydda efter din kurs.',
  'hero.heroBook.sectionSubHeadingV2': 'Dela in tuffa ämnen med begreppsförklaringar och övningsfrågor skräddarsydda efter din kurs.',
  'hero.SeeAllStudyOptions': 'Se alla studiealternativ',
  'hero.herobook.mappedChannelHeadingV1': 'Rekommenderade videor och övningsfrågor',
  'hero.popularTopics.headingV1': 'Andra populära ämnen',
  'hero.heroHeadingV1': 'För <span>{replace_value}</span>',
  'hero.learnmore': 'Läs mer',
  'hero.eTextbook': 'e-lärobok',
  'hero.goToPage.label': 'Gå till sidan',
  'subscription.studyTitle': 'Studieförberedelse',
  'print.printAvailTitle': 'Vill du skriva ut denna sida? Så här gör man',
  'print.printAvailDesc': 'I din eTexbook väljer du kontoikonen högst upp i höger hörn. Från alternativen väljer du "Skriv ut sida" och väljer sedan dina utskriftsinställningar.',
  'print.printNotAvailTitle': 'Utskriftsalternativet för denna e-text är inte aktiverat.',
  'print.printNotAvailDesc': 'För smidig tillgång offline kan du ladda ner din titel via Pearson+-mobilappen och njuta av flexibiliteten att kunna studera när som helst och var som helst!',
  'hero.header.cta': 'Gå till studieverktyg',
  'hero.header.ctav2': 'Öppna studieförberedelse',
  'hero.marketing.title': 'Hitta din e-lärobok',
  'hero.marketing.subTitle': 'Välj från över 2 000 e-läroböcker med ljudfiler, flashkort, anteckningar och mycket mer. Endast $10,99/må för en 4-månadersperiod.',
  'hero.popularchannels.desc': 'Få studiehjälp med dessa bästa ämnen',
  'hero.removecourse.title': 'Ta bort kursen från instrumentpanel?',
  'hero.removecourse.description': 'Du kan alltid lägga till denna kurs igen på din instrumentpanel genom att klicka på "Lägg till kurs"',
  'hero.removecourse.primaryCtaText': 'Ta bort',
  'hero.removecourse.secondaryCtaText': 'Avbryt',
  'hero.tableOfContents': 'Innehållsförteckning',
  'hero.search': 'Sök',
  'hero.emptystate.cta': 'Sök e-läroböcker',
  'hero.watch_it_again': 'Titta på den igen',
  'hero.mondly.learnLang.title': 'Lär dig ett nytt språk helt gratis',
  'hero.mondly.subTitle': 'Pearson e-lärobok-användare får tre månader av Mondly från Pearson.',
  'hero.mondly.description': 'De flesta appar för språkinlärning låter dig bara lära dig från engelska. Men det är bäst att lära sig från sitt modersmål, så Mondly låter dig lära dig från något av våra <strong>41 olika språk</strong>.',
  'hero.mondly.startLearningCTA': 'Börja lära dig',
  'hero.mondly.marketing.bestApp': 'Bästa appen',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Årets app',
  'hero.mondly.marketing.fbStart': 'Vinnare av Facebook FbStart – 2017 EMEA',
  'hero.mondly.marketing.editorChoice': 'Redaktionens val',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Lär dig ett språk',
  'header.menu.moreAtPearson': 'Mer hos Pearson',
  'hero.subscriptionStatusTitle2': 'Dina Pearson+-resurser',
  'hero.startStudying': 'Börja studera',
  'onboard.studyMaterials': 'Välj ditt ämne och vi kommer att skapa en instrumentpanel med anpassade studiematerial.',
  'hero.myETextbooks': 'Mina e-läroböcker',
  'header.continueInTheApp': 'Fortsätt i appen',
  'hero.learnTxt': 'Lär dig',
  'hero.examPrepTxt': 'Examensförberedelse',
  'hero.aITutorTxt': 'AI-lärare',
  'AI.toolTip': 'Fråga mig något i din e-lärobok',
  'hero.studyExamPrepAllYourCourses': 'Studieförberedelse för alla dina kurser',
  'header.qrCode.subHeaderTxt': 'Använd denna QR-kod för att snabbt och säkert logga in på Pearson+-appen på din mobila enhet.',
  'header.qrCode.dontHaveApp': 'Har du inte appen?',
  'header.qrCode.footerTxt': 'Om du skannar denna kod kommer du att omdirigeras till App Store eller Google Play. När appen är nedladdad loggar du in genom att skanna den igen.',
  'header.qrCode.errorMsg': 'QR-koden laddades inte. Stäng och försök igen.',
  'hero.yourETextbook': 'Din e-lärobok',
  'onboard.addCourseWithEtextBundle': 'Lägg till kurs med hjälp av Studieförberedelse',
  'onboard.disableTooltipText': 'Alla studieförberedelsekurser tillagda!',
  'subscriptionstatus.bundlecta': 'Åtkomst till studieförberedelse',
  'subscriptionstatus.nonbundlecta': 'Åtkomst till studieförberedelse',
  'channel.genericBundle': 'Använd din studieförberedelse som hjälp i dina andra kurser',
  'channel.relatedBundle': 'Använd även din studieförberedelsekurs som hjälp i dina andra kurser',
  'onboard.courseAdded': 'Kurs tillagd!',
  'hero.flashcards': 'Flashkort',
  'relatedChannelCard.title': 'Förbättra din inlärning med denna relaterade resurs',
  'relatedChannelCard.badgeText': 'Relaterad studieförberedelse',
  'sessionInactivity.title': 'Är du fortfarande kvar?',
  'sessionInactivity.description': 'Din session kommer att ta timeout om <b>%TIMER%</b> på grund av inaktivitet.<br/>Vill du förbli inloggad?',
  'sessionInactivity.keepMeSignIn': 'Håll mig inloggad',
  'sessionInactivity.signOut': 'Logga ut',
  'sessionTimeout.title': 'Session tog timeout',
  'sessionTimeout.description': 'Din session har tagit timeout på grund av inaktivitet.',
  'print.qrCode.header': 'Använd denna QR-kod för att öppna Pearson+-appen på din mobila enhet.',
  'print.qrCode.footer': 'Om du skannar denna kod kommer du att omdirigeras till App Store eller Google Play. När appen är installerad loggar du in för att ladda ner och få åtkomst till din titel.',
  'hero.nestest.title': 'Förbered dig för ditt lärarprov',
  'hero.nestest.subTitle': 'Användare av Pearson+ har nu tillgång till förberedelsekurser och övningstester som följer de nationella riktlinjerna, för att förbereda sig inför lärarproven.',
  'hero.channelAI.title': 'Behöver du hjälp? AI-lärare har din rygg.',
  'hero.channelAI.desc': 'Ställ en fråga och få stegvis hjälp med läxorna, studierekommendationer och mycket mer – personlig hjälp när du behöver det.',
  'hero.channelAI.action': 'Ställ fråga till AI-lärare nu',
  'new': 'Nytt!',
  'hero.practice.numOfUsers': 'Detta avsnitt har <b>{practice_num_of_users}</b> övningsuppgifter.',
  'hero.practice.cta': 'Öva nu',
  'hero.practice.title': 'Övningsuppgift',
  'diagnostics.errorMsg': 'Diagnostik laddades inte. Stäng och försök igen',
  'qrcode.title': 'Börja studera var som helst',
  'qrcode.subtitle': 'Lär dig var som helst och när som helst med Pearson+-mobilappen. Ladda ner nu och få tillgång till en smidig inlärningsupplevelse.',
  'qrcode.detailsv1': 'Med Pearson+-appen kan du använda denna QR-kod för att fortsätta där du slutade. Sök i din bok, studera med flashkort, titta på videolektioner och mycket mer, oavsett var du befinner dig.',
  'qrcode.detailsv2': 'Skanna denna QR-kod när du vill logga in snabbt och fortsätt precis där du slutade.',
  'qrcode.details': 'Med Pearson+-appen kan du använda denna QR-kod för att fortsätta där du slutade.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Lär dig var som helst och när som helst med Pearson+-mobilappen. Ladda ner nu och få tillgång till en smidig inlärningsupplevelse.',
  'install': 'Install',
  'header.menu.createCourse': 'Ny kurs',
  'header.dropdown.courses': 'Kurser',
  'header.dropdown.recentlyViewed': 'Senaste visade',
  'header.dropdown.viewAll': 'Visa alla kurser',
  'aet.courseHeader.inviteStudents': 'Bjud in studenter',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Bjud in studenter till att få tillgång till denna e-textbok genom att kopiera länkadressen eller instruktionerna nedan i ditt e-postmeddelande eller din kursplan.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Länkadress',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Kopiera länk',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instruktioner med länkadress',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Kopiera instruktioner',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Du kommer att ombes att logga in med ditt befintliga Pearson-konto. Om du inte ha ett Pearson-konto kommer du att få möjlighet till att skapa ett.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Startdatum:',
  'aet.courseHeader.endDate': 'Slutdatum:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Hantera förteckning',
  'aet.home.managegradesync': 'Hantera betygsynkronisering',
  'aet.home.copycourse': 'Kopiera kurs',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Nuvarande',
  'aet.instructorCourse.tabs.past': 'Tidigare',
  'aet.instructorCourse.tabs.courseSettings': 'Kursinställningar',
  'aet.instructorCourse.tabs.manageRoster': 'Hantera förteckning',
  'aet.instructorCourse.currentCourses.title': 'Nuvarande kurser',
  'aet.instructorCourse.pastCourses.title': 'Tidigare kurser',
  'aet.instructorCourse.createOrCopy.title': 'Skapa eller kopiera en kurs',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Kopiera en annan lärares kurs eller skapa en ny',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Kopiera en annan lärares kurs',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Ange kurs-ID:t för att hitta kursen som du vill kopiera.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Kurs-ID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Ange kurs-ID',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Du sökte efter',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Skapa ny kurs från katalogen',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Sök efter titel, författare, ISBN eller ämnesnyckelord.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Sök...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Visa mer',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Visa mindre',
  'aet.instructorCourse.cancel': 'Avbryt',
  'aet.instructorCourse.loading': 'Laddar ...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Betygsynkronisering',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Hantera betygsynkronisering',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Kursnamn',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Utan titel',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Avsnittsnamn',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Utan titel',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institution',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Institution är obligatoriskt',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Något gick fel. Försök igen.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Inga resultat hittades',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Kursens startdatum',
  'aet.instructorCourse.courseForm.endDateLabel': 'Kursens slutdatum',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/åå',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Tillåt andra att kopiera denna kurs',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Dela denna kod med lärarna som vill kopiera denna kurs',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Kopiera kod',
  'aet.instructorCourse.courseForm.optionalSuffix': '(valfritt)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Formuläret har ett valideringsfel',
  'aet.instructorCourse.courseForm.submitContinue': 'Fortsätt',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Sparar...',
  'aet.instructorCourse.courseForm.submitError': 'Vi kunde inte skapa din kurs. Försök igen.',
  'aet.instructorCourse.courseForm.submitEditError': 'Vi kunde inte spara dina ändringar. Försök igen.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Spara ändringar',
  'aet.instructorCourse.courseForm.materialsHeader': 'Kursmedel',
  'aet.instructorCourse.courseForm.resolveError': 'Vi kunde inte ladda kursmedlen. Försök igen.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Senaste visade',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Senaste tillagda',
  'aet.instructorCourse.coursesSort.aToZ': 'A till Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z till A',
  'aet.instructorCourse.manageRoster.column.name': 'Namn',
  'aet.instructorCourse.manageRoster.column.role': 'Roll',
  'aet.instructorCourse.manageRoster.column.email': 'E-post',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Student',
  'aet.instructorCourse.roster.role.ta': 'Lärarassistent',
  'aet.instructorCourse.roster.role.instructor': 'Lärare',
  'aet.instructorCourse.roster.status.active': 'Aktiv',
  'aet.instructorCourse.roster.status.inactive': 'Inaktiv',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Alla medlemmar',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Aktiva studenter',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Inaktiva studenter',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Lärarassistent',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Lärare',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Författare:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Kursens skapandedatum:',
  'aet.instructorCourse.noCoursesFound': 'Inga kurser hittades',
  'aet.instructorCourse.backButton': 'Tillbaka',
  'aet.instructorCourse.selectCourse': 'Välj kurs',
  'aet.home.linkedToLms': 'Länka till LMS',
  'aet.instructorCourse.courseForm.title.create': 'Skapa kurs',
  'aet.instructorCourse.courseForm.title.copy': 'Kopiera kurs',
  'aet.instructorCourse.courseForm.title.edit': 'Kursinformation',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Uppdrag',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Uppgiftsinnehåll',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Uppgiftens inlämningsdatum',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Markeringar och anteckningar',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Markeringsfärg',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Anteckningstext',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Delad status',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Studentförteckning och deltagande',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Studentnamn',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'E-postadresser',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Registrerade',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Slutförande och insikter',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Inställningar',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Kopierade data',
  'aet.studentRoster.manageStudentRosterButton': 'Hantera studentförteckning',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Exportera studentframsteg',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Registrerade:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Roll:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'I sin roll som lärarassistent kommer denna person att kunna följa alla studenters framsteg och prestationer i denna klass.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'De kommer också att kunna hantera studenter och uppgifter, men de kommer dock inte att kunna radera klassen.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Befordra till lärarassistent',
  'aet.home.manageRoster.searchPlaceholder': 'Sök efter student',
  'aet.home.manageRoster.inactivateButtonLabel': 'Inaktivera valda studenter',
  'aet.home.manageRoster.FilterLabel': 'Visa',
  'aet.home.manageRoster.updatingMessage': 'Uppdaterar förteckning... Detta kan ta några minuter.',
  'aet.home.courses.search.searchPlaceHolder': 'Sök dina kurser',
  'aet.courses.emptyStateDescription': 'Börja skapa din kurs genom att välja ett alternativ nedan.',
  'nativePromoBanner.continueInBrowser': 'Fortsätt i webbläsare',
  'globalnav.tooltip.hideNavText': 'Dölj navigering',
  'globalnav.tooltip.showNavText': 'Visa navigering',
  'aet.syllabus.progressTitle': 'Extraherar ...',
  'aet.syllabus.progressDesc': 'Vänta ett ögonblick medan vi behandlar din kursplan.',
  'aet.syllabus.uploadInputLabel': 'Dra och släpp filer här, eller klicka för att ladda upp',
  'aet.syllabus.uploadSyllabusTabLabel': 'Ladda upp kursplan',
  'aet.syllabus.dateAdjusterTabLabel': 'Datumväljare',
  'aet.syllabus.addManuallyTabLabel': 'Lägg till manuellt',
  'aet.syllabus.addEditLaterText': 'Du kan alltid lägga till och redigera uppgifter senare',
  'aet.syllabus.editAssignmentLabel': 'Redigera uppgift',
  'aet.syllabus.addAssignmentLabel': 'Lägg till uppgift',
  'aet.syllabus.assignmentTitleLabel': 'Uppgiftens namn',
  'aet.syllabus.dueDateLabel': 'Deadline',
  'aet.syllabus.editDueDateLabel': 'Redigera inlämningsdatum',
  'aet.syllabus.chaptersCoveredLabel': 'Välj vilka kapitel eller avsnitt som ska ingå.',
  'aet.syllabus.updateCtaLabel': 'Uppdatera uppgift',
  'aet.syllabus.addCtaLabel': 'Lägg till uppgift',
  'aet.syllabus.uploadLabel': 'Ladda upp',
  'aet.syllabus.confirmLabel': 'Bekräfta',
  'aet.syllabus.updateDatesLabel': 'Uppdatera datum',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': 'Radera uppgift?',
  'aet.deleteAssignmentTitleMultiple': 'Ta bort uppgifter?',
  'aet.deleteAssignmentWarning': 'Denna åtgärd kan inte återställas, och alla tillhörande inlämningar och studentuppgifter kommer att döljas.',
  'aet.deleteAssignmentKeepCTA': 'Behåll uppgift',
  'aet.deleteAssignmentDeleteCTA': 'Radera',
  'aet.assignments.loadingAsset': 'Laddar tillgång ...',
  'aet.assignments.allCaughtUpDescription': 'Inga uppgifter att lämna in den här veckan.',
  'aet.assignments.progressTitle': 'Förlopp',
  'aet.assignments.performanceTitle': 'Självförtroende',
  'aet.assignments.completionTitle': 'Slutförande',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Lägg till uppgift',
  'aet.assignments.deleteTooltip': 'Radera valda uppgifter',
  'aet.assignments.selectToDeleteLabel': 'Markera och ta bort',
  'aet.assignments.bulkEditTooltip': 'Redigera uppgifter i bulk',
  'aet.assignments.title': 'Uppdrag',
  'aet.assignments.assignmentTitle': 'Uppgift',
  'aet.assignments.dueDate': 'Deadline',
  'aet.tabular.searchPlaceholder.assignments': 'Sök uppgifter',
  'aet.tabular.searchPlaceholder.students': 'Sök studenter',
  'aet.tabular.searchPlaceholder.questions': 'Sök frågor',
  'aet.assignemnts.columnDueDateInfoTooltip': 'En eller flera studenter har fått förlängt inlämningsdatum för alla uppgifter',
  'aet.assignemnts.singleDueDateInfoTooltip': 'En eller flera studenter har fått förlängt inlämningsdatum för denna uppgift',
  'aet.assignemnts.masterDueDateInfoTooltip': 'En eller flera studenter har beviljats förlängt inlämningsdatum. Leta efter informationsikonen för att identifiera dessa uppgifter.',
  'aet.home.loading': 'Laddar ...',
  'aet.home.errorFetchingAssignments': 'Det gick inte att hämta uppgifterna',
  'aet.home.dueThisWeekTitle': 'Inlämningar denna vecka',
  'aet.home.allCaughtUpTitle': 'Inga fler uppgifter just nu!',
  'aet.home.allCaughtUpDescription': 'Inga uppgifter att lämna in den här veckan.',
  'aet.home.suggestedRemediationTitle': 'Föreslagen granskning av Studieförberedelse',
  'aet.home.noSuggestedRemediationTitle': 'Inget material föreslaget för granskning',
  'aet.home.noSuggestedRemediationDescription': 'Kom tillbaka efter din nästa uppgift.',
  'aet.home.assignmentIncludesTitle': 'Uppgiften inkluderar',
  'aet.home.sectionsLabel': 'Kapitel',
  'aet.home.questionsCount': '{count} frågor',
  'aet.home.dueLabel': 'Inlämningsdatum: {dueDate}',
  'aet.home.due': 'Förfaller:',
  'aet.home.progressCompletedLabel': 'Slutförd',
  'aet.home.progressCompletedPastDueLabel': 'Slutförda förfallna uppgifter',
  'aet.home.progressInProgressLabel': 'Pågår',
  'aet.home.progressNotStartedLabel': 'Ej påbörjad',
  'aet.home.progressCountOfTotal': '{count} av {total}',
  'aet.home.NotAttemptedLabel': 'Inte påbörjad',
  'aet.home.questionsTotalLabel': 'Totalt antal frågor',
  'aet.home.progressCompletedOnTimeLabel': 'Slutförd i tid',
  'aet.home.segmentGreatLabel': 'Utmärkt',
  'aet.home.segmentGettingThereLabel': 'Okej',
  'aet.home.segmentNeedsReviewLabel': 'Behöver förbättras',
  'aet.home.segmentOkayLabel': 'Okej',
  'aet.home.editAssignmentTooltip': 'Redigera uppgift',
  'aet.home.deleteAssignmentTooltip': 'Radera uppgift',
  'aet.home.viewDetailsButton': 'Visa mer information',
  'aet.home.viewAsStudentButton': 'Visa som student',
  'aet.home.welcomeButtonText': 'Komma igång →',
  'aet.review.emptyStateTitle': 'Det finns inget att granska',
  'aet.review.emptyStateDescription': 'Kom tillbaka efter din nästa uppgift.',
  'aet.dashboard.tabs.upNext': 'Näst på tur',
  'aet.dashboard.tabs.welcome': 'Välkommen',
  'aet.dashboard.tabs.assignments': 'Uppdrag',
  'aet.dashboard.tabs.review': 'Granska',
  'aet.dashboard.tabs.studentRoster': 'Studenter',
  'aet.dashboard.classSchedule': 'Lektionsschema:',
  'aet.syllabus.dueTimeLabel': 'Inlämningsdatum',
  'hero.accessEducatorGuides': 'Få tillgång till lärarhandledningar',
  'aet.assignment.save': 'Spara',
  'aet.assignment.saveAndAdd': 'Spara och lägg till en till',
  'aet.assignment.delete': 'Radera',
  'aet.assignment.saveAndClose': 'Spara och stäng',
  'aet.studentRoster.title': 'Studenter',
  'aet.studentRoster.titlev1': 'Student',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Inlämningsdatum',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standard',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 dagar',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 dagar',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 dagar',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 vecka',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 veckor',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Sista skoldagen',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} uppgifter uppdaterade',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Uppgifter efter inlämningsdatumen kunde inte uppdateras automatiskt. Redigera var och en för att ange ett nytt inlämningsdatum.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Det går inte att uppdatera inlämningsdatumen',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Inlämningsdatumet för alla uppgifter har passerat och kunde inte uppdateras automatiskt. Redigera var och en för att ange ett nytt inlämningsdatum.',
  'aet.bulkEdit.bulkSplitInstruction': 'Vi ser till att dina uppgifter fördelas jämnt.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Första uppgiften ska lämnas in den',
  'aet.bulkEdit.lastAssignmentDue': 'Sista uppgiften ska lämnas in den',
  'aet.bulkEdit.assignmentsDueDays': 'Vilka dagar vill du att uppgifterna ska lämnas in?',
  'aet.bulkEdit.addEditLaterText': 'Vi använder AI för att skapa uppgifter. Du kan alltid lägga till och redigera uppgifter senare.',
  'aet.bulkEdit.monday': 'Måndag',
  'aet.bulkEdit.tuesday': 'Tisdag',
  'aet.bulkEdit.wednesday': 'Onsdag',
  'aet.bulkEdit.thursday': 'Torsdag',
  'aet.bulkEdit.friday': 'Fredag',
  'aet.bulkEdit.saturday': 'Lördag',
  'aet.bulkEdit.sunday': 'Söndag',
  'aet.toast.assignmentCreated.title': 'Uppgiften har skapats!',
  'aet.toast.assignmentCreated.single': 'Den har automatiskt tilldelats namnet {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} uppgifter har skapats',
  'aet.toast.assignmentUpdated.title': 'Har uppdaterats.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} har uppdaterats',
  'aet.toast.assignmentUpdated.multiple': '{count} uppgifter har uppdaterats',
  'aet.toast.viewAssignment': 'Visa uppgift',
  'aet.toast.viewAssignments': 'Visa uppgifter',
  'aet.welcome.title': 'Din e-lärobok från Pearson är nu kopplad till din LMS-kurs',
  'aet.welcome.LMSAccounTitle': 'Utforska insikter',
  'aet.welcome.LMSAccounDescription': 'Se exakt vilka ämnen din klass kämpar med.',
  'aet.welcome.createAssignmentsTitle': 'Skapa uppgifter',
  'aet.welcome.createAssignmentsDescription': 'Tilldela kapitel manuellt eller genom att ladda upp kursplanen.',
  'aet.welcome.progressViewTitle': 'Håll koll på resultat i ditt LMS',
  'aet.welcome.progressViewDescription': 'Välj hur betyg ska synkroniseras i din LMS-kurs.',
  'aet.assignmentDetails.noAssignmentFound': 'Inga uppgifter hittades',
  'aet.assignments.loadingErrorTitle': 'Det går inte att ladda uppgiften just nu',
  'aet.assignments.loadingErrorDescription': 'Försök att uppdatera sidan eller kom tillbaka senare.',
  'aet.assignmentStudentDetails.noDataFound': 'Inga data ännu',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Inga studenter registrerade',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Studenterna får tillgång till din kurs när de köper e-läroboken.',
  'aet.home.editAssignmentTooltipDisabled': 'Kan inte redigeras: studenten arbetar fortfarande med uppgiften',
  'aet.home.deleteAssignmentTooltipDisabled': 'Kan inte raderas: studenten arbetar fortfarande med uppgiften',
  'aet.home.StudentDetails.questions': 'Frågor',
  'aet.home.StudentDetails.attempts': 'Försök',
  'aet.home.StudentDetails.comprehension': 'Självförtroende',
  'hero.titleInfo.tooltip': 'Titelinformation',
  'aet.home.publishAssignments': 'Publicera alla uppgifter',
  'aet.dashboard.footer': 'Visst innehåll har skapats med hjälp av AI baserat på Pearsons läromedel. Även om Pearson har en process för att validera resultatet kan generativ AI fortfarande producera felaktig information om personer, platser eller fakta.',
  'aet.home.bulkEditTitle': 'Redigera flera uppgifter samtidigt',
  'aet.home.bulkEditSubtitle': 'Ändra kursplanen och ladda sedan upp den här igen. Dina uppgifter och inlämningsdatum uppdateras enligt dessa ändringar.',
  'aet.home.createAssignmentTitle': 'Skapa uppgifter',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Ingår i en annan uppgift',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Vissa avsnitt ingår i en annan uppgift',
  'aet.welcome.welcome.Title': 'Välkommen!',
  'aet.home.student.roaster.ProgressTitle': 'Slutfört hittills',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Kom tillbaka när studenterna har påbörjat uppgiften.',
  'aet.home.whatDueThisWeekTitle': 'Veckans inlämningar',
  'aet.assignments.edit.errorTitle': '{count} uppgifter innehåller fel',
  'aet.assignments.edit.errorSubTitle': 'Det går inte att publicera uppgifter som innehåller fel. Redigera uppgifterna eller publicera utan dem.',
  'aet.assignments.edit.publishAnyway': 'Publicera ändå',
  'aet.assignments.edit.editAssignments': 'Redigera uppgifter',
  'aet.assignments.edit.validationInfoToolTip': 'Redigera uppgiften för att korrigera fel',
  'aet.assignments.error.assignmentCreated.title': 'Alla uppgifter innehåller fel',
  'aet.assignments.error.assignmentCreated.description': 'Det går inte att publicera uppgifter som innehåller fel. Redigera dem eller försök med en annan läroplan.',
  'aet.assignments.error.uploadSyllabus': 'Ladda upp kursplan',
  'aet.assignments.error.editAssignments': 'Redigera uppgifter',
  'aet.mondly.title': 'Språk',
  'aet.studentRoster.errorState.title': 'Studentlistan är inte tillgänglig',
  'aet.studentRoster.errorState.description': 'Det gick inte att ladda din studentlista. Försök att uppdatera sidan eller kom tillbaka senare.',
  'aet.assignments.sectionLabel': 'avsnitt',
  'aet.assignments.questionsLabel': 'fråga/frågor',
  'aet.assignments.assignmentsLabel': 'uppgift(er)',
  'aet.assignments.performanceProgressBar': 'Förloppsindindikator för resultat',
  'aet.assignments.completionProgressBar': 'Förloppsindindikator för slutförande',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Är du säker på att du vill radera den här uppgiften?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Är du säker på att du vill radera de här uppgifterna?',
  'aet.home.nextAssignmentTitle': 'Nästa uppgift',
  'aet.home.courseSettings': 'Kursinställningar',
  'aet.home.pearsonETextbookResources': 'Pearson+ e-lärobokresurser',
  'aet.home.etextbookInformation': 'Information om e-läroboken',
  'aet.multiple.deleteAssignmentKeepCTA': 'Behåll uppgift(er)',
  'aet.syllabus.processingText.header': 'Vi organiserar tilldelad läsning för din klass – det tar bara en liten stund.',
  'aet.syllabus.processingText.uploading': 'Laddar upp ditt dokument',
  'aet.syllabus.processingText.activating': 'Aktiverar AI-komponenter',
  'aet.syllabus.processingText.extracting': 'Extraherar läsuppgifter',
  'aet.syllabus.processingText.mapping': 'Mappar mot lärobokens innehåll',
  'aet.syllabus.processingText.finishing': 'Slutför',
  'aet.syllabus.uploadErrorMessage': 'Se till att din PDF- eller .docx-fil är under 10MB och att din internetanslutning är stabil',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Försök igen',
  'aet.syllabus.selectChapterWithQuestions': 'Välj ett kapitel med fråga/frågor.',
  'preferenceSetting.subTitle': 'Dessa inställningar kommer att vara standard för alla studenter i den här kursen.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'AI-interaktioner',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Aktivera AI-studieverktyg och AI-sammanfattningar i sökresultaten',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Visa studieförberedelser som hör till den här boken',
  'aet.syllabus.footer': 'Skapande av uppgifter drivs av AI',
  'aet.dashboard.footerDialogDeatils': 'Generativ AI används för att skapa uppgiftsfrågor utifrån Pearsons läromedel. Även om Pearson har en process för att verifiera resultatet kan generativ AI fortfarande producera felaktig information om personer, platser eller fakta. AI används också för att dela in innehållet i uppgifter, utifrån den kursplan och/eller det schema som du tillhandahåller.',
  'aet.review.footer': 'Skapad med hjälp av AI',
  'aet.footerCard.dismiss': 'Avvisa',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Studieförberedande material är ytterligare ett verktyg som underlättar inlärning genom att tillhandahålla studenter med videor och övningsuppgifter som är anpassade efter denna kurs.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Studenter vars åtkomstplan inte omfattar studieförberedande material kan ombes att prenumerera för att kunna fortsätta använda resurser i studieförberedande material.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Studenter som redan har köpt studieförberedande material kommer inte påverkas av denna inställning.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Läs mer om fördelarna med studieförberedande material',
  'aet.home.viewCourseId': 'Visa kurs-ID',
  'aet.home.copy': 'Kopiera',
  'aet.home.copied': 'Kopierad',
  'aet.home.courseLabel': 'Kurs-ID:',
  'schoolInfoCard.addUniversity': 'Lägg till skola',
  'schoolInfoCard.title': 'Skolinformation',
  'schoolInfoCard.titleV1': 'Berätta för oss om din kurs',
  'schoolInfoCard.cta': 'Komma igång',
  'schoolInfoCard.pickInstitution': 'Välj skola',
  'schoolInfoCard.addUniversityTitle': 'Lägg till din skola',
  'schoolInfoCard.addUniversitySubtitle': 'Om vi vet vilken skola och vilken kurs du läser kan vi rekommendera de mest användbara studiematerialen för dig.',
  'schoolInfoCard.searchPlaceholder': 'Sök efter din skola...',
  'schoolInfoCard.skip': 'Hoppa över detta steg',
  'schoolInfoCard.nextStep': 'Nästa steg',
  'schoolInfoCard.notInList': 'Min skola finns inte i listan',
  'schoolInfoCard.noResults': 'Inga skolor som matchar din sökning hittades',
  'schoolInfoCard.noResultsHeading': 'Kan du inte hitta din skola?',
  'schoolInfoCard.noResultsInstruction': 'Ange det fullständiga namnet nedan',
  'schoolInfoCard.noResultsInputPlaceholder': 'Skolans namn',
  'schoolInfoCard.addInstitutionLabel': 'Lägg till denna skola',
  'aet.assignments.assignmentTitlePlaceholder': 'Ange en titel',
  'aet.assignments.titleValidation.titleRequired': 'Uppgiftens namn är obligatorisk.',
  'aet.assignments.titleValidation.titleTooLong': 'Uppgiftens namn får inte överstiga {0} tecken.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Uppgiftens namn innehåller ogiltiga tecken.',
  'aet.assignments.titleValidation.titleDuplicate': 'Uppgiftens namn finns redan',
  'aet.syllabus.timeZoneLabel': 'Tidszon',
  'aet.review.reviewReadingFromAssignments': 'Gå igenom läsmaterialet från uppgiften',
  'aet.assignments.chaptersLabel': 'kapitel',
  'menu.myAccount.subTitle': 'Din institution finns här',
  'menu.myAccount.subTitleNotAvailable': 'Du kan när som helst lägga till institutionen här.',
  'schoolInfoCard.toastMessage': 'Universitet sparat',
  'aet.review.threeDotMenu.askAI': 'Fråga AI',
  'aet.home.suggestedRemediationSubtitle': 'Titta på relevanta videoklipp och öva för att behärska dina kursämnen.',
  'aet.home.laggedQuestionLabel': 'Markerade frågor',
  'aet.home.correctAnswer': 'Rätt svar',
  'aet.home.incorrectAnswer': 'Det vanligaste felaktiga svaret',
  'aet.home.behaviourTrendsLabel': 'Frågeinsikter',
  'aet.home.strugglingStudentsLabel': 'Studenter som upplever svårigheter',
  'aet.home.patternsInStudensAiLabel': 'AI-användning bland studenter',
  'aet.home.questionLabel': 'Fråga',
  'aet.home.studentAskingSimilarQuestions': 'Studenter som ställer liknande frågor',
  'aet.home.assignmentDifficultQuestions': 'Svåra frågor',
  'aet.home.behaviorTrends': 'Frågeinsikter',
  'aet.home.behaviors': 'Resultatindikatorer',
  'aet.home.mostDifficultTopics': 'De svåraste frågorna',
  'aet.home.commentsFromStudentLabel': 'Kommentarer från studenter',
  'aet.home.disregard': 'Ignorera',
  'aet.home.reportAsInaccurate': 'Rapportera som felaktig',
  'aet.home.Flagged': 'Markerad',
  'aet.home.reportQuestionTitle': 'Rapportera fråga',
  'aet.home.reportQuestionLabel': 'Vad var problemet med den här frågan?',
  'aet.home.showComments': 'Visa kommentarer',
  'aet.home.studentReports': 'studentrapporter',
  'aet.home.placeholderText': 'Förklara...',
  'aet.home.reportQuestion.notRelevant': 'Inte relevant',
  'aet.home.reportQuestion.notCorrect': 'Inte rätt',
  'aet.home.reportQuestion.unsafe': 'Farligt/skadligt',
  'aet.home.reportQuestion.somethingElse': 'Någonting annat',
  'aet.home.StudentDetails.assistedByAI': 'Med hjälp av AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Inga studenter har problem just nu',
  'aet.home.strugglingStudents.emptyStateDescription': 'Kom tillbaka lite senare.',
  'aet.home.overallStatus.excelling': 'Presterar mycket väl',
  'aet.home.overallStatus.fallingBehind': 'Ligger efter',
  'aet.home.overallStatus.keepingUp': 'I fas',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Visa endast "Svåra frågor"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Visa endast "Studenter som upplever svårigheter"',
  'aet.home.viewQuestionInAssignment': 'Visa fråga i uppgift',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Felaktiga första försök',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Flera felaktiga försök',
  'aet.home.insightRisk.lowConfidence': 'Lågt självförtroende',
  'aet.home.insightRisk.mediumConfidence': 'Medelhögt självförtroende',
  'aet.home.insightRisk.lowEngagement': 'Lågt engagemang',
  'aet.home.insightRisk.countOfStudents': '{count} av {total} studenter',
  'aet.home.insightRisk.na': 'Ej tillämpligt',
  'aet.home.strugglingStudentsHereLabel': 'Studenter som upplever svårigheter här',
  'aet.home.insightRisk.didNotAttempt': 'Försökte inte',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default sv;
